export const hi = {
  translation: {
    totalkendra: "कुल केन्द्र",
    tolfree: "टोलफ्री",
    english: "अंग्रेज़ी",
    hindi: "हिंदी",
    Home: "होम",
    Message: "संदेश",
    From: "प्रेषक",
    ChairpersonsDesk: "अध्यक्ष डेस्क",
    CEOsDesk: "सीईओ डेस्क",
    Governance: "शासन",
    GoverningCouncil: "शासन करने वाली परिषद",
    GoverningCouncilMember: "शासन करने वाली परिषद सदस्य",
    ExecutiveCouncilMember: "कार्यकारी परिषद सदस्य",
    ExecutiveCouncil: "कार्यकारी परिषद",
    OrganizationChart: "संगठन चार्ट",
    ManagementTeam: "प्रबंधन टीम",
    PMBJP: "पीएमबीजेबी",
    pmbjbkendraregistration: "पीएमबीजेबी केन्द्रा रजिस्ट्रेशन",
    AboutPmbjb: "योजना के बारे मे ",
    PMBI: "पीएमबीआई",
    OldApplicatonPortal: "पुराना आवेदन पोर्टल",
    pmbitext:
      "फार्मास्यूटिकल्स एंड मेडिकल डिवाइसेज ब्यूरो ऑफ इंडिया (पीएमबीआई) प्रधानमंत्री भारतीय जनऔषधि परियोजना (पीएमबीजेपी) की कार्यान्वयन एजेंसी है। पीएमबीआई की स्थापना दिसंबर, 2008 में भारत सरकार के फार्मास्यूटिकल्स विभाग के तहत की गई थी। ब्यूरो को सोसायटी पंजीकरण अधिनियम के तहत एक स्वतंत्र सोसायटी के रूप में पंजीकृत किया गया है।",
    pmbitext2:
      "फार्मास्यूटिकल्स एंड मेडिकल डिवाइसेज ब्यूरो ऑफ इंडिया (पीएमबीआई) प्रधानमंत्री भारतीय जनऔषधि परियोजना (पीएमबीजेपी) की कार्यान्वयन एजेंसी है। पीएमबीआई की स्थापना दिसंबर, 2008 में फार्मास्यूटिकल्स विभाग के तहत की गई थी।",
    PMBJPScheme: "पीएमबीजेपीयोजना",
    objectives: "लक्ष्य",
    objectivetext:
      "सभी को सस्ती कीमतों पर गुणवत्तापूर्ण जेनेरिक दवाएं उपलब्ध कराने के उद्देश्य से, भारत सरकार के रसायन और उर्वरक मंत्रालय के फार्मास्यूटिकल्स विभाग द्वारा नवंबर, 2008 में प्रधान मंत्री भारतीय जनऔषधि परियोजना (पीएमबीजेपी) शुरू की गई थी। इस योजना के तहत, समर्पित सस्ती कीमतों पर जेनेरिक दवाएं उपलब्ध कराने के लिए जनऔषधि केंद्र के नाम से जाने जाने वाले आउटलेट खोले गए हैं। 11.06.2025 तक, देश भर में 16000 से ज्यादा जनऔषधि केंद्र कार्यरत हैं। पीएमबीजेपी की उत्पाद टोकरी में 2047 दवाएं और 300 सर्जिकल आइटम शामिल हैं। यह योजना सोसायटी पंजीकरण अधिनियम, अर्थात फार्मा एंड मेडिकल ब्यूरो ऑफ इंडिया (पीएमबीआई) [तत्कालीन ब्यूरो ऑफ फार्मा पीएसयू ऑफ इंडिया (बीपीपीआई)] के तहत पंजीकृत सोसायटी द्वारा कार्यान्वित की जाती है।",
    objectivetext1:
      "» 1. सभी के लिए किफायती मूल्य पर गुणवत्तापूर्ण दवाइयां, उपभोग्य वस्तुएं और शल्य चिकित्सा संबंधी वस्तुएं उपलब्ध कराना तथा उपभोक्ताओं/मरीजों की जेब से होने वाले खर्च को कम करना।",
    objectivetext2:
      "» 2. आम जनता के बीच जेनेरिक दवाओं को लोकप्रिय बनाना तथा इस प्रचलित धारणा को दूर करना कि कम कीमत वाली जेनेरिक दवाएं घटिया गुणवत्ता वाली या कम प्रभावी होती हैं।",
    objectivetext3:
      "» 3. पूरे भारत में सभी महिलाओं को मासिक धर्म स्वास्थ्य सेवाओं की आसान उपलब्धता सुनिश्चित करना।",
    objectivetext4:
      "» 4. जन औषधि केन्द्र खोलने में व्यक्तिगत उद्यमियों को शामिल करके रोजगार सृजन करना।",
    silentfeature: "मुख्य विशेषताएँ",
    silentsubheadtext:
      "यह योजना सरकारी एजेंसियों द्वारा भी संचालित की जाती है निजी उद्यमियों द्वारा:",
    silentfeaturetext:
      "1. जन औषधि दवाओं की कीमतें खुले बाजार में उपलब्ध ब्रांडेड दवाओं की कीमतों से 50%-80% कम हैं।",
    silentfeaturetext2:
      "2. उत्पादों की गुणवत्ता सुनिश्चित करने के लिए दवाएं केवल विश्व स्वास्थ्य संगठन - अच्छे विनिर्माण अभ्यास (डब्ल्यूएचओ-जीएमपी) प्रमाणित निर्माताओं से ही खरीदी जाती हैं।",
    silentfeaturetext3:
      "3. सर्वोत्तम गुणवत्ता सुनिश्चित करने के लिए दवा के प्रत्येक बैच का परीक्षण ‘राष्ट्रीय परीक्षण और अंशांकन प्रयोगशाला प्रत्यायन बोर्ड’ (एनएबीएल) द्वारा मान्यता प्राप्त प्रयोगशालाओं में किया जाता है।",
    silentfeaturetext4:
      "4. 20,000/- रुपये प्रति माह तक का प्रोत्साहन मासिक खरीद के 20% की दर से दिया जाता है तथा यह स्टॉकिंग अधिदेश के अधीन है।",
    silentfeaturetext5:
      "5. पूर्वोत्तर राज्यों, हिमालयी क्षेत्रों, द्वीप क्षेत्रों और नीति आयोग द्वारा आकांक्षी जिले के रूप में उल्लिखित पिछड़े क्षेत्रों या महिला उद्यमी, पूर्व सैनिक दिव्यांग, अनुसूचित जाति और अनुसूचित जनजाति द्वारा खोले गए पीएमबीजेपी केंद्रों को 2.00 लाख रुपये की एकमुश्त प्रोत्साहन राशि प्रदान की जाती है।",
    sanitarynapkintext:
      "भारतीय महिलाओं के लिए स्वास्थ्य सुरक्षा सुनिश्चित करने की दिशा में एक महत्वपूर्ण कदम के रूप में, जन औषधि सुविधा ऑक्सो-बायोडिग्रेडेबल सैनिटरी नैपकिन 27 अगस्त 2019 को लॉन्च किए गए, जिन्हें केवल 1 रुपये प्रति पैड की दर से उपलब्ध कराया जाएगा। जन औषधि सुविधा नैपकिन देश भर में 16000 से अधिक पीएमबीजेपी केंद्रों पर बिक्री के लिए उपलब्ध कराए जा रहे हैं। 31.01.2025 तक सुविधा नैपकिन की संचयी बिक्री 72 करोड़ है।",
    mobileapplicationtext:
      'मोबाइल एप्लिकेशन "जन औषधि सुगम" अगस्त, 2019 में लॉन्च किया गया था। ऐप में विभिन्न सुविधाएं हैं उपयोगकर्ता के अनुकूल सुविधाएँ जैसे - Google मानचित्र के माध्यम से नजदीकी जन औषधि केंद्र का पता लगाना, जन औषधि जेनेरिक दवाओं की खोज करना, जेनेरिक की कीमतों की तुलना करना एमआरपी, समग्र बचत आदि के संदर्भ में बनाम ब्रांडेड दवाएं।',
    mobileapplication: "जनऔषधि सुगम मोबाइल एप्लिकेशन",
    publicity: "जागरूकता और प्रसार",
    publicitytext:
      "जनता में जागरूकता सुनिश्चित करने के लिए, प्रिंट, आउटडोर, टीवी और अन्य जैसे विभिन्न मीडिया प्लेटफॉर्म; सोशल मीडिया आदि का प्रयोग नियमित रूप से किया जा रहा है। सरकार भी एकीकृत दृष्टिकोण अपना रही है राज्य सरकारों के साथ पीएमबीजेपी के बारे में जागरूकता फैलाने के लिए। पूरे भारत में केंद्र मालिकों, डॉक्टरों और विभिन्न महत्वपूर्ण गणमान्य व्यक्तियों के साथ प्रचार कार्यशालाएँ भी आयोजित की जाती हैं।",
    publicitytext2:
      "केंद्रों में ग्राहकों की संख्या बढ़ाने के लिए दवाओं की पूरी श्रृंखला उपलब्ध कराने के लिए उत्पाद टोकरी का भी विस्तार किया गया है।",
    publicitytext3:
      "नई दवाएं और न्यूट्रास्यूटिकल्स उत्पाद जैसे प्रोटीन पाउडर, माल्ट-आधारित खाद्य पूरक और ग्लूकोमीटर आदि लॉन्च किए गए हैं।",
    publicitytext4:
      "राज्य स्वास्थ्य और संबंधित सरकारी अधिकारियों से नियमित आधार पर विभिन्न सरकारी अस्पतालों और संबंधित परिसरों में जन औषधि केंद्र खोलने का अनुरोध किया गया है। किराया मुक्त स्थान प्रदान करके।",
    savings: "नागरिकों के लिए बचत",
    abpmjayheading: "एबी पीएम-जे अस्पताल",
    savingstext:
      "अनुमान है कि पीएमबीजेपी ने लगभग रुपये से अधिक की बचत हासिल की। देश के आम नागरिकों का 30,000 करोड़ रु.",
    impactofpmbjb: "पीएमबीजेबी का प्रभाव",
    impacttext:
      "इस योजना ने आम जनता को सस्ती कीमत पर गुणवत्तापूर्ण दवाएं उपलब्ध कराई हैं। केंद्रों की संख्या 16,000 से अधिक हो गई है और सभी जिलों को कवर कर लिया गया है। यह योजना स्थायी और नियमित कमाई के साथ स्वरोजगार का एक अच्छा स्रोत भी प्रदान कर रही है। प्रति माह प्रति केंद्र औसत बिक्री बढ़ी है 1.50 लाख रुपये तक सरकार द्वारा भारत में जेनेरिक दवाओं के उपयोग को लोकप्रिय बनाने के लिए और अधिक कदम उठाए जा रहे हैं, बिक्री में वृद्धि होना तय है।",
    impactsubtext: "यह योजना वास्तव में अपनी टैगलाइन के साथ न्याय कर रही है",
    impactsubtext2: "जन औषधि - सेवा के साथ-साथ रोजगार",
    LocatePMBJPKendra: "स्थापित केंद्र",
    LocateDistributor: "स्थापित वितरक",
    ABPMJAYHospital: "एबीपीएमजय अस्पताल",
    ABPMJAYHospitalheading: "एबीपीएमजय सूचीबद्ध अस्पताल खोजें",
    AnnualReport: "वार्षिक रिपोर्ट",
    FinancialReport: "वित्तीय रिपोर्ट",
    PharmacistDetails: "फार्मासिस्ट विवरण",
    PharmacistDetailsheading: "फार्मासिस्ट की राज्यवार उपलब्धता",
    searchbutton: "खोज़े",
    FAQs: "पूछे जाने वाले प्रश्न",
    faq: "अक्सर पूछे जाने वाले प्रश्नों",
    productportfolio: "उत्पाद पोर्ट्फोलिओ",
    productmrplist: "उत्पाद एवं एमआरपी सूची",
    productviewlist: "उत्पाद सूची (सॉर्टिंग-व्यू)",
    tender: "निविदा",
    Tenders: " निविदाएं",
    TenderDetails: "लाइव निविदा",
    BlackList: "काली सूची",
    AwardedTender: "पुरस्कृत निविदा",
    RevocationOrder: "रद्दीकरण आदेश",
    DebarredList: "प्रतिष्ठित सूची",
    Media: "मिडिया",
    EventCalendar: "कार्यक्रम का कैलेंडर",
    ContactUs: "संपर्क करें",
    Recruitment_header: "नियुक्तियाँ",
    ContactUsfooter: "संपर्क करें",
    Support: "सहायता",
    SupportFooter: "सहायता",
    PACSTraining: "PACS प्रशिक्षण",
    POSTraining: "POS प्रशिक्षण",
    DownloadTrainingLink: "प्रशिक्षण लिंक डाउनलोड करें",
    RetailSoftwareHelpline: "रिटेल सॉफ़्टवेयर हेल्पलाइन",
    sugamapp: "सुगम ऐप",
    SugamAppHelpline: "सुगम ऐप हेल्पलाइन",
    SugamAppDownload: "डाउनलोड सुगम ऐप",
    AndroidApp: "एंड्रॉइड ऐप",
    iOSApp: "iOS ऐप",
    KendraComplaints: "केन्द्रा शिकायतें",
    VendorLabPortal: "वेंडर लैब पोर्टल",
    WebinarTutorials: "वेबिनार ट्यूटोरियल्स",
    ApplyForKendra: "केंद्र के लिए आवेदन करें",
    apply: "आवेदन करना",
    recentvaccancy: "नई भर्ती",
    clickheretoapply: " रजिस्ट्रेशन करने के लिए यहां क्लिक करें",
    rtinote: "नोट: प्राप्त सभी आवेदनों का निपटारा सूचना का अधिकार अधिनियम, 2005 के प्रावधानों के तहत किया जाएगा।",
    Initiatives: "पहल",
    ABOUTUS: "हमारे बारे में",
    RTI: "आरटीआई",
    TESTIMONIALS: "प्रशंसापत्र",
    SITEMAP: "साइटमैप",
    RECRUITMENTS: "नियुक्तियाँ",
    RECRUITMENTSFooter: "नियुक्तियाँ",
    OtherLinks: "अन्य लिंक",
    NeedHelp: "मदद चाहिए ?",
    COPYRIGHT: "कॉपीराइट",
    HYPERLINKPOLICY: "हाइपरलिंक नीति",
    PRIVACYPOLICY: "गोपनीयता नीति",
    DISCLAIMER: "अस्वीकृति",
    TAC: "नियम और शर्तें",
    FEEDBACK: "प्रतिक्रिया",
    ARCHIVE: "संग्रह",
    Address: "पता",
    newaddress:
      "बी-500, बी-टावर, 5वीं मंजिल, नौरोजी नगर, वर्ल्ड ट्रेड सेंटर, नई दिल्ली-110029",
    TollFreeNo: "टोल फ्री नंबर",
    OfficeTiming: "कार्यालय का समय",
    nearkendra: "अपने मोबाइल पर अपने निकटतम पीएमबीजेपी केंद्र का पता लगाएं",
    downloadtext: "अब डाउनलोड करो! जनऔषधि आनंद",
    scanapp: "ऐप डाउनलोड करने के लिए क्यूआर कोड को स्कैन करें",
    AreYouAPharmacist: "क्या आप फार्मासिस्ट हैं!",
    Registerhere: "यहां रजिस्टर करें",
    nearPharmacist: "स्थापित फार्मासिस्ट",
    nearbykendra: "स्थापित केंद्र",
    searchKendraCode: "केंद्र कोड",
    searchTender: "निविदा खोजें",
    searchDebarred: "प्रतिष्ठित सूची खोजें",
    searchBlackList: "काली सूची खोजें",
    searchAwardedTender: "पुरस्कृत निविदा खोजें",
    searchRevocationOrder: "रद्दीकरण आदेश खोजें",
    modiname: "श्री नरेन्द्र मोदी",
    modiprofession: "भारत के माननीय प्रधान मंत्री",
    Vision: "दृष्टि",
    visiontext:
      "प्रदान करके भारत के प्रत्येक नागरिक के स्वास्थ्य देखभाल बजट को कम करना",
    Visiontext2: "किफायती दामों पर गुणवत्तापूर्ण जेनेरिक दवाएं",
    mansukhname: "डॉ. मनसुख मंडाविया",
    mansukhprofession:
      "माननीय केंद्रीय मंत्री स्वास्थ्य एवं परिवार कल्याण एवं रसायन एवं उर्वरक",
    bhagwanthname: "श्री भगवंत खुबै",
    bhagwanthprofession:
      "माननीय राज्य मंत्री रसायन एवं उर्वरक तथा नवीन एवं नवीकरणीय ऊर्जा",
    whatsnew: "नया क्या है",
    newsletters: "न्यूज़लेटर",
    bannertext:
      'पीएम मोदी ने वीडियो कॉन्फ्रेंसिंग के जरिए "विकसित भारत संकल्प यात्रा" के लाभार्थियों से भी बातचीत की।',
    kedranumber: "पीएम मोदी ने जनऔषधि केंद्रों को बढ़ाने की पहल शुरू की",
    arunishname: "श्री अरुणीश चावला",
    arunishprofession: "एलएएस सचिव",
    wish: "शुभकामनाएं",
    aandolan: "आइये.......इस आंदोलन से जुड़ें",
    Raviname: "श्री रवि दाधीच,डीएएनआईसीएस",
    RaviProfession: "मुख्य कार्यकारी अधिकारी",
    ravimission:
      "पीएमबीआई, नेक मिशन प्रधानमंत्री भारतीय जनऔषधि परियोजना (पीएमबीजेपी) की कार्यान्वयन एजेंसी किफायती कीमतों पर गुणवत्तापूर्ण जेनेरिक दवाएं और सर्जिकल उपकरण उपलब्ध कराने में महत्वपूर्ण रही है।",
    rtiheader: "पीएमबीआई के अपील प्राधिकारी और सीपीआईओ",
    rtidescription:
      "देश के सभी नागरिक सूचना के अधिकार के प्रावधानों के तहत पीएमबीजेपी योजना के संबंध में जानकारी प्राप्त कर सकते हैं,जनऔषधि से जुड़े मामलों के संबंध में अधिनियम, 2005 को लिखित रूप में आवेदन देकर:",
    rtitext: "सूचना का अधिकार",
    rtibutton: "आवेदन करें / अपील करें",
    cpio: "केन्द्रीय लोक सूचना अधिकारी",
    appelate: "अपील प्राधिकरण",
    timing: "सुबह 9:30 बजे से शाम 6:00 बजे तक",
    weekday: "(सोमवार से शुक्रवार)",
    trainingschedule: "प्रशिक्षण कार्यक्रम",
    pacs: "पीएसीएस आवेदकों के लिए प्रशिक्षण कार्यक्रम",
    pos: "पीओएस  प्रशिक्षण",
    posschedule: "पीएमबीजेके और वितरकों के लिए पीओएस अनुसूची",
    postutorial: "पीओएस ट्यूटोरियल",
    kendracomplaints: "केन्द्रा शिकायतें",
    complaints: "शिकायतें",
    softwarehelpline: "सॉफ्टवेयर हेल्पलाइन",
    sugampapp: "सुगम ऐप हेल्पलाइन",
    sugamapplication: "जनऔषधि सुगम एप्लीकेशन हेल्पलाइन",
    vendarlab: "विक्रेता/लैब पोर्टल",
    webinartutorial: "वेबिनार/ट्यूटोरियल",
    login_welcomeback: "आपका स्वागत है",
    login_account: "नीचे अपने खाते में लॉगिन करें",
    emailid: "ईमेल आईडी",
    mobilenumber: "मोबाइल नंबर",
    entermobilenumber: "अपना मोबाइल नंबर दर्ज करे",
    userid: "यूजर आईडी",
    enteruserid: "अपना यूजर आईडी दर्ज करे",
    enterotp: "ओटीपी दर्ज करें",
    enteyourrotp: "अपना ओटीपी दर्ज करें",
    getotp: "ओटीपी दर्जकरें",
    enterpassword: "पासवर्ड दर्ज करें",
    entercaptcha: "केप्चा भरे",
    captchcode: "कैप्चा कोड",
    enteremail: "अपना ईमेल आईडी दर्ज करें ",
    confirmpassword: "पासवर्ड की पुष्टि कीजिये",
    enterconfirmpassword: "अपना कन्फर्म पासवर्ड दर्ज करें",
    name: "नाम",
    entername: "अपना नाम नाम दर्ज करें",
    selectlogin: "लॉगिन के लिए मोड का चयन करें",
    loginbutton: "लॉगिन करें",
    forgotpassword: "पासवर्ड भूल गए?",
    emailandmobile: "ईमेल आईडी/मोबाइल नंबर",
    enteremailandmobile: "अपना ईमेल आईडी/मोबाइल नंबर दर्ज करें",
    forget:
      "कृपया सत्यापन प्रक्रिया के लिए अपना ईमेल आईडी/मोबाइल नंबर दर्ज करें, हम आपके ईमेल/मोबाइल नंबर पर 6 अंकों का कोड भेजेंगे",
    continuebutton: "जारी रखें",
    backto: "वापस",
    donthaveaccount: "कोई खाता नहीं है?",
    registernow: "अभी रजिस्ट्रेशन करे",
    open: "कैसे खोलें",
    janushadhikendra: "जनऔषधि केंद्र",
    register: "रजिस्ट्रेशन",
    createaccount: "खाता बनाएं",
    registersubheading:
      "अपना खाता बनाने और आरंभ करने के लिए नीचे अपना विवरण दर्ज करें।",
    alreadyhaveaccount: "क्या आपके पास पहले से एक खाता मौजूद है?",
    acknowledgment: "18 वर्ष और उससे अधिक की आयु होनी चाहिए",
    pharmaregister: "फार्मासिस्ट रजिस्ट्रेशन",
    address: "पता",
    enteraddress: "अपना पता दर्ज करें",
    enterpin: "पिन कोड दर्ज करें",
    selectdistrict: "जिला चुनें",
    selectstate: "राज्य चुनें",
    state: "--राज्य चुनें--",
    district: "--जिला चुनें--",
    SearchNearestKendra: "केंद्र खोजें",
    SearchNearestPharma: "फार्मासिस्ट खोजें",
    SearchlocateDistributor: "वितरक खोजें",
    TotalCount: "कुल संख्या",
    POSText: "पीओएस/डीपीओएस हेल्पलाइन नंबर: 0124-3561100",
    noteText: "नोट:-",
    TMSPortal: "टीएमएस पोर्टल तक पहुंचने के लिए कृपया यहां क्लिक करें",
    DisclaimerDetailspera1:
      "यह वेबसाइट और इस वेबसाइट की सामग्री सामान्य जानकारी या उपयोग के लिए संबंधित सरकारी विभाग/संगठन/एजेंसी द्वारा स्वामित्व, अद्यतन और रखरखाव की जाती है और फार्मास्यूटिकल्स एंड मेडिकल डिवाइसेज ब्यूरो ऑफ इंडिया (पीएमबीआई) द्वारा होस्ट की जाती है।",
    DisclaimerDetailspera2:
      "हालाँकि इस वेबसाइट पर सामग्री की सटीकता और प्रासंगिकता सुनिश्चित करने के लिए सभी प्रयास किए गए हैं, लेकिन इसे कानून के बयान के रूप में नहीं समझा जाना चाहिए या किसी कानूनी उद्देश्यों के लिए उपयोग नहीं किया जाना चाहिए। एनआईसी सामग्री की सटीकता, पूर्णता, उपयोगिता या अन्यथा के संबंध में कोई जिम्मेदारी स्वीकार नहीं करता है। उपयोगकर्ताओं को सलाह दी जाती है कि वे संबंधित सरकारी विभाग / संगठन / एजेंसी और / या अन्य स्रोतों से किसी भी जानकारी को सत्यापित / जांचें, और प्राप्त करें वेबसाइट में दी गई जानकारी पर कार्रवाई करने से पहले कोई उचित पेशेवर सलाह।",
    DisclaimerDetailspera3:
      "किसी भी स्थिति में सरकार या एनआईसी किसी भी खर्च, हानि या क्षति के लिए उत्तरदायी नहीं होगी, जिसमें बिना किसी सीमा के, अप्रत्यक्ष या परिणामी हानि या क्षति, या डेटा के उपयोग, या उपयोग की हानि से उत्पन्न होने वाला कोई भी खर्च, हानि या क्षति शामिल है। इस वेबसाइट के उपयोग से बाहर या इसके संबंध में।",
    DisclaimerDetailspera4:
      "इस वेबसाइट पर शामिल की गई अन्य वेबसाइटों के लिंक केवल सार्वजनिक सुविधा के लिए प्रदान किए गए हैं। एनआईसी लिंक की गई वेबसाइटों की सामग्री या विश्वसनीयता के लिए जिम्मेदार नहीं है और जरूरी नहीं कि उनमें व्यक्त किए गए दृष्टिकोण का समर्थन करता हो। हम हर समय ऐसे लिंक किए गए पेजों की उपलब्धता की गारंटी नहीं दे सकते।",
    tacDetails:
      "नियम और शर्तें भारतीय कानूनों द्वारा शासित होंगी। कार्यक्रम से उत्पन्न होने वाले किसी भी और सभी विवाद, विवाद और संघर्ष (विवाद) को नियमित न्यायिक प्रक्रिया के माध्यम से निपटाया जाएगा और इससे उत्पन्न होने वाले किसी भी मामले पर दिल्ली की अदालत का विशेष क्षेत्राधिकार होगा और इकाई का दायित्व ग्राहकों से इकाई द्वारा वसूले गए और प्राप्त किए गए पंजीकरण शुल्क की सीमा तक सीमित होगा।",

    Linkstootherwebsites: "अन्य वेबसाइटों/पोर्टलों द्वारा वेबसाइट के लिंक",
    LinkstootherwebsitesSetails:
      "किसी भी वेबसाइट या पोर्टल से हाइपरलिंक को इस साइट पर निर्देशित करने से पहले पूर्व अनुमति आवश्यक है। इसके लिए अनुमति, उन पृष्ठों पर सामग्री की प्रकृति बताते हुए जहां से लिंक दिया जाना है और हाइपरलिंक की सटीक भाषा प्राप्त की जानी चाहिए। संगठन के सक्षम प्राधिकारी को अनुरोध भेजना।",
    Linkstoexternalwebsites: "बाहरी वेबसाइटों/पोर्टलों के लिंक",
    LinkstoexternalwebsitesDetails:
      "इस वेबसाइट में कई स्थानों पर आपको अन्य वेबसाइटों और पोर्टलों के लिंक मिलेंगे। आपकी सुविधा के लिए लिंक डाल दिए गए हैं। वेबसाइटें और पोर्टल लिंक की गई वेबसाइटों की सामग्री और विश्वसनीयता के लिए ज़िम्मेदार नहीं हैं और जरूरी नहीं कि उनमें व्यक्त विचारों का समर्थन करें। इस पोर्टल पर केवल लिंक की उपस्थिति या इसकी सूची को किसी भी प्रकार का समर्थन नहीं माना जाना चाहिए। हम इसकी गारंटी नहीं दे सकते कि ये लिंक हर समय काम करेंगे और लिंक किए गए पृष्ठों की उपलब्धता पर हमारा कोई नियंत्रण नहीं है।",
    copyrightData:
      "इस पोर्टल पर प्रदर्शित सामग्री को हमें एक मेल भेजकर उचित अनुमति लेने के बाद नि:शुल्क पुन: प्रस्तुत किया जा सकता है। हालाँकि, सामग्री को सटीक रूप से पुन: प्रस्तुत किया जाना चाहिए और अपमानजनक तरीके से या भ्रामक संदर्भ में उपयोग नहीं किया जाना चाहिए। जहां भी सामग्री प्रकाशित की जा रही है या दूसरों को जारी की जा रही है, स्रोत को प्रमुखता से स्वीकार किया जाना चाहिए। हालाँकि, इस सामग्री को पुन: प्रस्तुत करने की अनुमति किसी भी ऐसी सामग्री तक नहीं दी जाएगी, जिसे किसी तीसरे पक्ष के कॉपीराइट के रूप में पहचाना गया हो। ऐसी सामग्री को पुन: प्रस्तुत करने का प्राधिकरण संबंधित विभागों/कॉपीराइट धारकों से प्राप्त किया जाना चाहिए।",
    versionUpdate: "नवीनतम संस्करण",
    totalvisitor: "साइट पर कुल आगंतुक",
    footercopyright_1: "कॉपीराइट",
    footercopyright_2: "फार्मास्यूटिकल्स एंड मेडिकल डिवाइसेज ब्यूरो ऑफ इंडिया(पीएमबीआई) सर्वाधिकार सुरक्षित।",
    privacymessage:
      "यह वेबसाइट स्वचालित रूप से किसी विशिष्ट चीज़ को कैप्चर नहीं करती है आपसे व्यक्तिगत जानकारी (जैसे नाम, फ़ोन नंबर या) ईमेल पता), जो हमें आपकी पहचान करने की अनुमति देता है व्यक्तिगत रूप से. यदि आप हमें अपना प्रदान करना चुनते हैं व्यक्तिगत जानकारी, जैसे नाम या पता, जब आप हमारी वेबसाइट पर जाएँ, हम इसका उपयोग केवल आपके अनुरोध को पूरा करने के लिए करते हैं जानकारी के लिए। हम व्यक्तिगत रूप से कुछ भी बेचते या साझा नहीं करते हैं पहचान योग्य जानकारी इस साइट पर किसी को भी स्वेच्छा से दी जाती है तृतीय पक्ष। इस वेबसाइट पर प्रदान की गई कोई भी जानकारी होगी हानि, दुरुपयोग, अनधिकृत पहुंच आदि से सुरक्षित रहें प्रकटीकरण, परिवर्तन, या विनाश।",
    privacymessage2:
      "हम उपयोगकर्ता के बारे में कुछ जानकारी इकट्ठा करते हैं, जैसे इंटरनेट प्रोटोकॉल (आईपी) पता, डोमेन नाम, ब्राउज़र प्रकार, ऑपरेटिंग सिस्टम, विज़िट की तारीख और समय और पेज देखे गए. हम इन पतों को जोड़ने का कोई प्रयास नहीं करते हैं हमारी साइट पर आने वाले व्यक्तियों की पहचान के साथ जब तक साइट को नुकसान पहुंचाने के प्रयास का पता चला है।",
    app: "ऐप गोपनीयता नीति",
    appmessage:
      "फार्मास्यूटिकल्स एंड मेडिकल डिवाइसेज ब्यूरो ऑफ इंडिया (पीएमबीआई) ने जन औषधि सुगम ऐप को एक मुफ्त ऐप के रूप में बनाया है। यह सेवा फार्मास्यूटिकल्स एंड मेडिकल डिवाइसेज ब्यूरो ऑफ इंडिया (पीएमबीआई) द्वारा बिना किसी लागत के प्रदान की जाती है और यह वैसे ही उपयोग के लिए है।",
    appmessage2:
      "यदि कोई हमारी सेवा का उपयोग करने का निर्णय लेता है तो इस पृष्ठ का उपयोग आगंतुकों को व्यक्तिगत जानकारी के संग्रह, उपयोग और प्रकटीकरण के साथ हमारी नीतियों के बारे में सूचित करने के लिए किया जाता है।",
    appmessage3:
      "यदि आप हमारी सेवा का उपयोग करना चुनते हैं, तो आप इस नीति के संबंध में जानकारी के संग्रह और उपयोग के लिए सहमत हैं। हम जो व्यक्तिगत जानकारी एकत्र करते हैं उसका उपयोग सेवा प्रदान करने और उसमें सुधार करने के लिए किया जाता है। इस गोपनीयता नीति में वर्णित के अलावा हम आपकी जानकारी का उपयोग या किसी के साथ साझा नहीं करेंगे।",
    appmessage4:
      "इस गोपनीयता नीति में उपयोग किए गए शब्दों का वही अर्थ है जो हमारे नियमों और शर्तों में है, जो जन औषधि सुगम में उपलब्ध है, जब तक कि इस गोपनीयता नीति में अन्यथा परिभाषित न किया गया हो।",
    information: "सूचना संग्रहण एवं उपयोग",
    informationmessage:
      "बेहतर अनुभव के लिए, हमारी सेवा का उपयोग करते समय, हमें आपसे कुछ व्यक्तिगत पहचान योग्य जानकारी प्रदान करने की आवश्यकता हो सकती है, जिसमें लॉगिन उद्देश्य के लिए मोबाइल नंबर, ईमेल पता शामिल है, लेकिन यह इन्हीं तक सीमित नहीं है। हमारे द्वारा अनुरोधित जानकारी हमारे पास रहेगी और इस गोपनीयता नीति में वर्णित अनुसार उपयोग की जाएगी।",
    informationmessage2:
      "ऐप तृतीय पक्ष सेवाओं का उपयोग करता है जो आपकी पहचान करने के लिए उपयोग की जाने वाली जानकारी एकत्र कर सकता है।",
    logdata: "लॉग डेटा",
    logdatamessage:
      "हम आपको सूचित करना चाहते हैं कि जब भी आप हमारी सेवा का उपयोग करते हैं, तो ऐप में त्रुटि के मामले में हम आपके फोन पर लॉग डेटा नामक डेटा और जानकारी (तीसरे पक्ष के उत्पादों के माध्यम से) एकत्र करते हैं। इस लॉग डेटा में आपके डिवाइस का इंटरनेट प्रोटोकॉल आईपी पता , डिवाइस का नाम, ऑपरेटिंग सिस्टम संस्करण, हमारी सेवा का उपयोग करते समय ऐप का कॉन्फ़िगरेशन, सेवा के आपके उपयोग का समय और तारीख और अन्य आंकड़े जैसी जानकारी शामिल हो सकती है।",
    cookies: "कुकीज़",
    cookiesdata:
      "कुकीज़ थोड़ी मात्रा में डेटा वाली फ़ाइलें होती हैं जिन्हें आमतौर पर अज्ञात विशिष्ट पहचानकर्ताओं के रूप में उपयोग किया जाता है। ये आपके द्वारा देखी जाने वाली वेबसाइटों से आपके ब्राउज़र पर भेजे जाते हैं और आपके डिवाइस की आंतरिक मेमोरी में संग्रहीत होते हैं।",
    cookiesdata2:
      'यह सेवा इन "कुकीज़" का स्पष्ट रूप से उपयोग नहीं करती है। हालाँकि, ऐप तीसरे पक्ष के कोड और लाइब्रेरी का उपयोग कर सकता है जो जानकारी एकत्र करने और अपनी सेवाओं को बेहतर बनाने के लिए "कुकीज़" का उपयोग करते हैं। आपके पास इन कुकीज़ को स्वीकार करने या अस्वीकार करने का विकल्प है और आप जान सकते हैं कि आपके डिवाइस पर कोई कुकी कब भेजी जा रही है। यदि आप हमारी कुकीज़ को अस्वीकार करना चुनते हैं, तो आप इस सेवा के कुछ हिस्सों का उपयोग नहीं कर पाएंगे।',
    services: "सेवा प्रदाताओं",
    servicesdata: "हम निम्नलिखित कारणों से तृतीय-पक्ष कंपनियों और व्यक्तियों को नियुक्त कर सकते हैं:",
    servicesBulletpoint1: "• हमारी सेवा को सुविधाजनक बनाने के लिए।",
    servicesBulletpoint2: "• हमारी ओर से सेवा प्रदान करना।",
    servicesBulletpoint3: "• सेवा-संबंधी सेवाएँ निष्पादित करना।",
    servicesBulletpoint4: "• हमारी सेवा का उपयोग कैसे किया जाता है इसका विश्लेषण करने में हमारी सहायता करना।",
    servicesdata2:
      "हम इस सेवा के उपयोगकर्ताओं को सूचित करना चाहते हैं कि इन तृतीय पक्षों के पास आपकी व्यक्तिगत जानकारी तक पहुंच है। इसका कारण हमारी ओर से उन्हें सौंपे गए कार्यों को करना है। हालाँकि, वे किसी अन्य उद्देश्य के लिए जानकारी का खुलासा या उपयोग नहीं करने के लिए बाध्य हैं।",
    Security: "सुरक्षा",
    securitymessage:
      "हमें आपकी व्यक्तिगत जानकारी प्रदान करने में आपके विश्वास को महत्व देते हैं, इसलिए हम इसकी सुरक्षा के लिए व्यावसायिक रूप से स्वीकार्य साधनों का उपयोग करने का प्रयास कर रहे हैं। लेकिन याद रखें कि इंटरनेट पर प्रसारण की कोई भी विधि, या इलेक्ट्रॉनिक भंडारण की कोई भी विधि 100% सुरक्षित और विश्वसनीय नहीं है, और हम इसकी पूर्ण सुरक्षा की गारंटी नहीं दे सकते।",
    links: "अन्य साइटों के लिए लिंक",
    linksdata:
      "इस सेवा में अन्य साइटों के लिंक शामिल हो सकते हैं। यदि आप किसी तृतीय-पक्ष लिंक पर क्लिक करते हैं, तो आपको उस साइट पर निर्देशित किया जाएगा। ध्यान दें कि ये बाहरी साइटें हमारे द्वारा संचालित नहीं हैं। इसलिए, हम आपको इन वेबसाइटों की गोपनीयता नीति की समीक्षा करने की दृढ़ता से सलाह देते हैं। किसी भी तीसरे पक्ष की साइटों या सेवाओं की सामग्री, गोपनीयता नीतियों या प्रथाओं पर हमारा कोई नियंत्रण नहीं है और हम इसके लिए कोई ज़िम्मेदारी नहीं लेते हैं।",
    children: "बच्चों की गोपनीयता",
    childrendata:
      "ये सेवाएँ 13 वर्ष से कम उम्र के किसी भी व्यक्ति को संबोधित नहीं करती हैं। हम जानबूझकर 13 वर्ष से कम उम्र के बच्चों से व्यक्तिगत रूप से पहचान योग्य जानकारी एकत्र नहीं करते हैं। यदि हमें पता चलता है कि 13 वर्ष से कम उम्र के बच्चे ने हमें व्यक्तिगत जानकारी प्रदान की है, तो हम इसे तुरंत अपने सर्वर से हटा देते हैं। यदि आप माता-पिता या अभिभावक हैं और आप जानते हैं कि आपके बच्चे ने हमें व्यक्तिगत जानकारी प्रदान की है, तो कृपया हमसे संपर्क करें ताकि हम आवश्यक कार्रवाई कर सकें।",
    privacychange: "इस गोपनीयता नीति में परिवर्तन",
    privacychangedata:
      "हम समय-समय पर अपनी गोपनीयता नीति को अपडेट कर सकते हैं। इस प्रकार, आपको किसी भी बदलाव के लिए समय-समय पर इस पृष्ठ की समीक्षा करने की सलाह दी जाती है। हम इस पृष्ठ पर नई गोपनीयता नीति पोस्ट करके आपको किसी भी बदलाव के बारे में सूचित करेंगे। ये परिवर्तन इस पृष्ठ पर पोस्ट होने के तुरंत बाद प्रभावी हो जाते हैं।",
    Contact: "संपर्क करें",
    contactmessage:
      "यदि हमारी वेबसाइट के बारे में आपके पास कोई तकनीकी प्रश्न या सुझाव है, तो हमसे फोन पर संपर्क करने में संकोच न करें: 011-49431800, ईमेल: it[at]janaushadhi[dot]gov[dot]in",
    hospitalType: "अस्पताल का प्रकार चुनें",
    sitemap: "साइट मानचित्र",
    archivehome: "संग्रह-होम",
    archive: "संग्रह",
    blacklist: "काले सूची में शामिल विक्रेता",
    debarredlist: "निषेधित विक्रेता सूची",
    recruitments: "भर्तियाँ",
    reports: "रिपोर्टें",
    Others: "अन्य",
    gallery: "गैलरी",
    eventMaterial: "घटना सामग्री",
    screenReaderAccess: "इससे व्यक्ति जिनकी दृष्टिगति कमजोर है, तकनीकों जैसे स्क्रीन रीडर का उपयोग करके वेबसाइट तक पहुँच सकते हैं। वेबसाइट की जानकारी को JAWS, NVDA, SAFA, Supernova और Window-Eyes जैसे विभिन्न स्क्रीन रीडर्स के साथ पहुँची जा सकती है।",
    tableInfo: "निम्नलिखित तालिका विभिन्न स्क्रीन रीडर्स के बारे में जानकारी देती है।",
    infoRelated: "विभिन्न स्क्रीन रीडर्स से संबंधित जानकारी",
    screenrecoderaccess: "स्क्रीन रीडर एक्सेस",
    ReadMore: "और पढ़ें",
    Title13: "प्रधानमंत्री भारतीय जनऔषधि केंद्र खोलने की प्रक्रिया क्या है?",
    Content13: "विस्तृत दिशानिर्देश और प्रक्रिया के लिए, कृपया हमारी वेबसाइट पर 'केन्द्र के लिए आवेदन करें' पर क्लिक करें।",
    List1: "आवश्यक न्यूनतम स्थान जो PMBI द्वारा अनुमोदित मानकों के अनुसार हो।",
    List2: "संविधानिक प्राधिकरण से बिक्री लाइसेंस (आवेदक के नाम पर खुदरा औषधि लाइसेंस और/या टीआईएन नंबर)।",
    List3: "फार्मासिस्ट की नियुक्ति का प्रमाण (फार्मासिस्ट का नाम, राज्य परिषद के साथ पंजीकरण आदि प्रदान करना आवश्यक है)।",
    List4: "स्टोर चलाने की वित्तीय क्षमता को दस्तावेज़ (आईटीआर, बैंक स्टेटमेंट, पैन/आधार आदि) द्वारा प्रस्तुत करना।",
    List5: "‘प्रधानमंत्री जनऔषधि केंद्र’ के नाम पर ड्रग लाइसेंस।",
    Title12: "सरकारी नामांकित के अलावा संगठन / व्यक्ति द्वारा प्रधानमंत्री जनऔषधि केंद्र खोलने की आवश्यकताएँ क्या हैं?",
    Content12: "स्वामित्व वाली जगह या किराए की जगह, जिसे उचित लीज़ एग्रीमेंट द्वारा समर्थित किया गया हो।",
    list1: "व्यक्तिगत उद्यमी / स्वामी",
    list2: "साझेदारी",
    list3: "चैरिटेबल संस्थान / अस्पताल",
    list4: "एनजीओ / ट्रस्ट / समाज",
    list5: "सरकार / सरकारी नामांकित एजेंसी",
    list6: "अन्य (कृपया निर्दिष्ट करें)",
    Title11: "प्रधानमंत्री जनऔषधि केंद्र कौन खोल सकता है?",
    Title10: "प्रधानमंत्री जनऔषधि केंद्रों के लिए दवाइयाँ कैसे खरीदी और आपूर्ति की जाती हैं?",
    Content10: "दवाइयाँ निजी निर्माताओं और सीपीएसयू से ओपन टेंडर सिस्टम के माध्यम से खरीदी जाती हैं। खरीदी गई प्रत्येक बैच की दवाइयों का मान्यता प्राप्त एनएबीएल प्रयोगशालाओं से परीक्षण किया जाता है और वितरण नेटवर्क के माध्यम से केंद्र को भेजा जाता है।",
    Title9: "प्रधानमंत्री जनऔषधि केंद्रों के खुलने और बंद होने का समय क्या है?",
    Content9: "प्रधानमंत्री जनऔषधि केंद्रों का सामान्य कार्यकाल सुबह 8 बजे से शाम 8 बजे तक होता है।",
    Title8: "अब तक कितने प्रधानमंत्री जनऔषधि केंद्र खोले गए हैं और उनके स्थान क्या हैं?",
    Content8: "वर्तमान में 10,300 से अधिक केंद्र कार्यशील हैं। राज्यवार / जिलेवार पीएमबीजेके की सूची और उनके स्थान पीएमबीआई की वेबसाइट पर ‘PMBJP => PMBJP Kendra’ शीर्षक के अंतर्गत उपलब्ध है।",
    Title7: "प्रधानमंत्री जनऔषधि केंद्रों पर कौन-कौन सी दवाइयाँ उपलब्ध हैं और उनकी कीमतें क्या हैं?",
    Content7: "पीएमबीआई की कोशिश है कि जनऔषधि स्टोर्स पर सभी चिकित्सीय दवाइयाँ उपलब्ध करवाई जाएं। वर्तमान में उपलब्ध दवाइयों की एमआरपी के साथ सूची 'PMBJP Products - Therapeutic Groups' शीर्षक के अंतर्गत पीएमबीआई की वेबसाइट पर दी गई है। इस सूची में अधिक दवाइयाँ जोड़ी जा रही हैं।",
    Title6: "जेनेरिक दवाइयाँ मरीजों को कैसे लाभ पहुंचाती हैं?",
    Content6: "जेनेरिक दवाइयाँ लेने से मरीज अपनी दवाइयों पर खर्च को बहुत अधिक कम कर सकता है।",
    Title5: "क्या जेनेरिक दवाइयाँ ब्रांडेड दवाइयों के समान प्रभावशाली होती हैं?",
    Content5: "जेनेरिक दवाइयों की प्रभावशीलता और चिकित्सीय मूल्य ब्रांडेड दवाइयों के समान होता है।",
    Title4: "दवाइयों की गुणवत्ता, सुरक्षा और प्रभावशीलता कैसे सुनिश्चित की जाती है?",
    Content4: "दवाइयों की गुणवत्ता, सुरक्षा और प्रभावशीलता सुनिश्चित की जाती है द्वारा हर बैच की दवाइयों का सीपीएसयू और निजी आपूर्तिकर्ताओं से प्राप्त करने के बाद एनएबीएल-स्वीकृत प्रयोगशालाओं से परीक्षण कराना और आवश्यक मानकों का पालन करना, इसके बाद दवाइयों को पीएमबीआई के वेयरहाउस से सुपर स्टॉक्स/प्रधानमंत्री भारतीय जनऔषधि केंद्रों को आपूर्ति की जाती है।",
    Title3: "पीएमबीआई क्या है?",
    Content3: "पीएमबीआई (फार्मास्यूटिकल्स एंड मेडिकल डिवाइसेस ब्यूरो ऑफ इंडिया) को भारत सरकार के औषधि विभाग के तहत स्थापित किया गया है, जिसमें सभी सीपीएसयू के सहयोग से प्रधानमंत्री भारतीय जनऔषधि केंद्रों के माध्यम से जेनेरिक दवाइयों की खरीद, आपूर्ति और विपणन का समन्वय किया जाता है।",
    Title2: "जेनेरिक दवा क्या है?",
    Content2: "जेनेरिक दवाइयाँ एक गैर-स्वामित्व या अनुमोदित नाम के तहत विपणन की जाती हैं, न कि स्वामित्व या ब्रांड नाम के तहत। जेनेरिक दवाइयाँ अपनी ब्रांडेड समकक्ष दवाइयों की तुलना में समान रूप से प्रभावी और सस्ती होती हैं।",
    Title1: "प्रधानमंत्री भारतीय जनऔषधि परियोजना (PMBJP) क्या है?",
    Content1: "‘प्रधानमंत्री भारतीय जनऔषधि परियोजना (PMBJP)’ एक अभियान है जिसे औषधि विभाग द्वारा केंद्रीय फार्मा पब्लिक सेक्टर अंडरटेकिंग्स के सहयोग से शुरू किया गया है, जिसका उद्देश्य 'प्रधानमंत्री भारतीय जनऔषधि केंद्र' के नाम से जाने वाले समर्पित आउटलेट्स के माध्यम से जनता को सस्ती कीमत पर गुणवत्तापूर्ण दवाइयाँ प्रदान करना है। ये केंद्र जेनेरिक दवाइयाँ बहुत कम कीमत पर उपलब्ध कराते हैं। इन दवाइयों की प्रभावशीलता उन महंगी ब्रांडेड दवाइयों के समान होती है जो खुले बाजार में उपलब्ध हैं।",
    Videos: "वीडियो",
    Successstory: "सफलता की कहानी",
    Gallery: "गैलरी",
    GalleryDetails: "गैलरी विवरण",
    ArchiveGallery: "संग्रह गैलरी",
    FindProductdetails: "उत्पाद विवरण खोजें",
    PinCode: "पिन कोड",
    pinCodeBySearch: "पिन कोड द्वारा खोजें",

  },
};
